var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "debt snowball") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A7BF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4AD6F9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,18.13l-4.24,1.54-2.3-1.35,2.1-1.1a.75.75,0,0,0,.05-1.3l-2.82-1.79,3-1.72L28,14a.75.75,0,0,0,.53-1.4l-3-1.14,2.72-1.54a.75.75,0,0,0-.74-1.3l-2.72,1.55.57-3.22a.75.75,0,1,0-1.48-.26l-.78,4.44-2.63,1.49.11-2.56a.75.75,0,0,0-1.1-.7l-2.65,1.39,0-3.3,3.47-2.85a.75.75,0,1,0-1-1.16L16.82,5.5l0-3.12a.75.75,0,0,0-.74-.76h0a.75.75,0,0,0-.75.74l0,3.13L12.82,3.4a.75.75,0,1,0-1,1.15l3.46,2.9,0,3.21L12.82,9.09a.75.75,0,0,0-1.15.6l-.12,2.83L9,11,8.27,6.6a.75.75,0,1,0-1.48.25L7.32,10,4.63,8.46a.75.75,0,1,0-.76,1.29l2.7,1.58L3.5,12.46A.75.75,0,1,0,4,13.87l4.24-1.54,2.61,1.53L8.12,15.29a.75.75,0,0,0-.05,1.3l2.55,1.62L8.2,19.57,4,18a.75.75,0,1,0-.53,1.4l3,1.14L3.78,22.08a.75.75,0,0,0,.74,1.3l2.72-1.55-.57,3.22a.75.75,0,0,0,.61.87h.13a.75.75,0,0,0,.74-.62l.78-4.44,2.31-1.31-.12,2.9a.75.75,0,0,0,1.1.7l3-1.56,0,2.95-3.47,2.85a.75.75,0,1,0,1,1.16l2.5-2.06,0,3.12a.75.75,0,0,0,.74.76h0a.75.75,0,0,0,.75-.74l0-3.13,2.51,2.1a.75.75,0,1,0,1-1.15l-3.46-2.9,0-2.48,2.14,1.36a.75.75,0,0,0,1.15-.6l.15-3.53L23,21l.73,4.43a.75.75,0,0,0,.74.63h.12a.75.75,0,0,0,.62-.86L24.68,22l2.69,1.58a.75.75,0,0,0,.76-1.29l-2.7-1.58,3.07-1.12A.75.75,0,0,0,28,18.13Zm-6.28-1.63-1.78.93L17.5,16l1.81-1ZM19,11.3l-.09,2.2-2.13,1.21,0-2.25Zm-5.87-.25,2.16,1.37,0,2.27L13,13.38ZM10,16l2.42-1.27L14.5,16l-2.42,1.37Zm2.72,5.21.11-2.54,2.45-1.39,0,2.6Zm6-2.71-.12,3L16.72,20.3l0-3,2,1.15S18.68,18.49,18.68,18.51Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bb59f9684cf85510ad7bb3eaa80b777c.svg";
export { ForwardRef as ReactComponent };